const state = {
  token: "",
  user: null,
};

// 同步修改状态
const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_USER(state, userInfo) {
    state.user = userInfo;
  },
  // 可选：清除用户信息（退出登录时使用）
  CLEAR_USER(state) {
    state.token = "";
    state.user = null;
  },
};

// 异步操作（这里暂时没有，保留结构）
const actions = {
  // 例如登录 action
  // login({ commit }, userData) { ... }
};

// 派生数据（根据需要添加）
const getters = {
  isLogin: (state) => !!state.token,
  userName: (state) => state.user?.name || "",
};

export default {
  namespaced: true, // 开启命名空间，避免 mutation/action 冲突
  state,
  mutations,
  actions,
  getters,
};
